import React from 'react';
import { MobileContainer } from '@components/organism/MobileContainer';
import { DriverDocumentsDetailsArea } from '@components/molecules/DriverDocumentsDetailsArea/DriverDocumentsDetailsArea';

export function EditDocuments() {
    return (
        <MobileContainer>
            <DriverDocumentsDetailsArea />
        </MobileContainer>
    );
}
